module.exports = __webpack_public_path__ + "027ecf77187a42d20e9e9e94ff118153.png";